import axios from "axios";
import authHeader from "./token.interceptor";

const API_URL = process.env.REACT_APP_API_URL;

export const searchAnnonces = async (params: {
  search?: string;
  rccm?: string;
  page?: number;
  page_size?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.rccm) queryParams.append("rccm", params.rccm);
  if (params.page) queryParams.append("page", String(params.page));
  if (params.page_size) queryParams.append("page_size", String(params.page_size));

  return await axios.get(
    `${API_URL}/formalite/annonces/liste_unifiee/?${queryParams.toString()}`,
    { headers: authHeader() }
  );
};

export const getAnnonceDetail = async (id: string | number) => {
  return await axios.get(
    `${API_URL}/formalite/annonces/${id}/detail_unifiee/`,
    { headers: authHeader() }
  );
};
